import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-pdf-viewer__loading"
}
const _hoisted_2 = {
  key: 1,
  class: "app-pdf-viewer__error"
}
const _hoisted_3 = {
  key: 2,
  class: "app-pdf-viewer__container"
}
const _hoisted_4 = ["src"]

import { ref } from 'vue';
// @ts-ignore
import { watch, onMounted } from 'vue';

interface Props {
  pdfUrl: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SimplePDFViewer',
  props: {
    pdfUrl: {}
  },
  setup(__props: any) {

/// <reference types="vue" />
// @ts-ignore
const props = __props;

const loading = ref<boolean>(true);
const error = ref<string | null>(null);

// Function to validate URL
const validateUrl = (url: string): boolean => {
  if (!url) {
    console.error('PDF URL is empty or undefined');
    error.value = 'No PDF URL provided';
    return false;
  }

  try {
    new URL(url); // This will throw if URL is invalid
    return true;
  } catch (e) {
    console.error('Invalid PDF URL:', e);
    error.value = 'Invalid PDF URL';
    return false;
  }
};

watch(() => props.pdfUrl, (newUrl: string) => {
  if (newUrl) {
    console.log('PDF URL changed:', newUrl);
    if (validateUrl(newUrl)) {
      loading.value = false;
      error.value = null;
    } else {
      loading.value = false;
    }
  } else {
    loading.value = true;
    error.value = 'No PDF URL provided';
  }
}, { immediate: true });

onMounted(() => {
  if (props.pdfUrl) {
    loading.value = false;
  } else {
    loading.value = true;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-pdf-viewer app-pdf-viewer--simple", { 'app-pdf-viewer--loading': loading.value }])
  }, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "app-loading-spinner" }, null, -1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('common.loading')), 1)
        ]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)),
            _createElementVNode("p", null, _toDisplayString(error.value), 1),
            _renderSlot(_ctx.$slots, "error-actions")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("iframe", {
              src: _ctx.pdfUrl + '#toolbar=1&navpanes=0&scrollbar=0&page=1&view=FitH',
              class: "app-pdf-viewer__iframe",
              frameborder: "0",
              scrolling: "no",
              allowfullscreen: ""
            }, null, 8, _hoisted_4)
          ]))
  ], 2))
}
}

})